import {
  ServiceNames,
  ServiceStatus,
} from "@nvs/gatsby-theme-leap-core/src/components/hoc/constants/service.constants";
import { EnrollmentContextService } from "@nvs/gatsby-theme-leap-core/src/components/hoc/context/enrollment/enrollment-context";
import { servicesMapper as themeServicesMapper } from "@nvs/gatsby-theme-leap-core/src/components/hoc/context/enrollment/mappers/services";
import { Service } from "@nvs/gatsby-theme-leap-core/src/components/hoc/context/product/configuration-model";
import { KisqaliQuestionsConstants } from "../../../../../../../constants/kisqali-questions-constants";

export const servicesMapper = (
  context: Service[],
  enrollmentContext: EnrollmentContextService
): {
  name: string;
  state?: string;
  data?: string;
}[] => {
  const services: {
    name: string;
    state?: string;
    data?: string;
  }[] = themeServicesMapper(context, enrollmentContext);
  const adherence = services.find(
    (service) => service.name === ServiceNames.adherence
  );
  const fto = services.find((service) => service.name === ServiceNames.fto);
  if (adherence) {
    adherence.data = JSON.stringify({
      primaryCondition: enrollmentContext.getQuestion(
        KisqaliQuestionsConstants.patientCondition
      )?.answer as string | undefined,
    });
  }
  if (fto) {
    fto.state = ServiceStatus.confirmed;
  }
  return services;
};
